module.exports = __webpack_public_path__ + "static/media/Table_Before.ba35214d.jpg";